export enum ProductTagType {
  User = 0,
  Company = 1,
}
